import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import { bindActionCreators } from 'redux';
import { getValuesEmployeesNumber, changeValueEmployeesNumber } from '../actions';
import CircularProgress from 'material-ui/CircularProgress';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import { getRecords } from '../../GenericTablePagination/actions';
import SelectFieldFormat from '../../fields/SelectFieldFormat/SelectFieldFormat';
import _ from 'lodash';

class FilterEmployeesNumberGeneric extends Component {

    constructor(props){
        super(props);
        this._onChangeEmployeesNumber = this._onChangeEmployeesNumber.bind(this);
        this._execGetRecords = this._execGetRecords.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { getValuesEmployeesNumber } = this.props;
        getValuesEmployeesNumber();
    }

    _onChangeEmployeesNumber(e, index, value){
        const { changeValueEmployeesNumber, extra } = this.props;
        let extraData = extra;
        changeValueEmployeesNumber(value);
        this._execGetRecords(_.set(extraData, 'numEmployees', value));
    }

    _execGetRecords(extraData){
        const {
            URL,
            version,
            skip,
            limit,
            orderName,
            orderType,
            textFilter,
            body,
            textValueTag,
            textTag,
            coreName,
            getRecords
        } = this.props;
        let arrayFields = [];
        _.map(body, function(field){
             if(!_.has(field, 'actions') && _.has(field, 'filter')){
                 if(_.get(field, 'filter')){
                     arrayFields.push(_.get(field, 'field'));
                 }
             }
        });
        getRecords(URL, version, skip, limit, orderName, orderType, arrayFields, textFilter, coreName, extraData);
    }

    render() {
        const { employeesNum, employeesNumber } = this.props;
        return (
            <SelectFieldFormat
                config={{
                    floatingLabelText: "Número de empleados",
                    value: employeesNum,
                    autoWidth: true,
                    onChange: this._onChangeEmployeesNumber
                }}
            >
                <MenuItem key={`employeesNum0`} value={'all'} primaryText={'Todos'}/>
                {
                    _.map(_.orderBy(employeesNumber, ['order']), (item, index) => {
                        return (
                            <MenuItem key={`${_.get(item, '_id')}_ne_${index}`} value={_.get(item, '_id')} primaryText={_.get(item, 'value')}/>
                        );
                    })
                }
            </SelectFieldFormat>
        );
    }
}

function mapStateToProps({ filterCompany, genericTablePagination }, ownProps) {
    const tablePagination = genericTablePagination.get(_.get(ownProps, 'coreName', 'default'));
    return {
        employeesNumber: filterCompany.get("employeesNumber"),
        employeesNum: filterCompany.get("employeesNum"),
        skip: tablePagination.get('skip'),
        limit: tablePagination.get('limit'),
        orderName: tablePagination.get('orderName'),
        orderType: tablePagination.get('orderType'),
        textFilter: tablePagination.get('textFilter'),
        status: _.isNull(tablePagination.get('status')) ? 'all' : tablePagination.get('status')
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getValuesEmployeesNumber,
        changeValueEmployeesNumber,
        getRecords
    }, dispatch);
}

FilterEmployeesNumberGeneric.propTypes = {
    URL: PropTypes.string.isRequired,
    version: PropTypes.number.isRequired,
    extra: PropTypes.object.isRequired,
    body: PropTypes.array.isRequired,
    coreName: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterEmployeesNumberGeneric);
